import { render, staticRenderFns } from "./WaitView.vue?vue&type=template&id=ecdfa4f2&scoped=true"
import script from "./WaitView.vue?vue&type=script&lang=js"
export * from "./WaitView.vue?vue&type=script&lang=js"
import style0 from "./WaitView.vue?vue&type=style&index=0&id=ecdfa4f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdfa4f2",
  null
  
)

export default component.exports